<template>
  <el-upload  accept="image/jpeg,image/jpg,image/png" class="upImg_uploader"
             :multiple="false" :show-file-list="false"
              action="####"
              v-loading="loading"
              :disabled="disabled || status == 1"
             :http-request="uploadAttrFile"
             :before-upload="beforeUpload">
    <div class="box-upload" v-if="upImgUrl">
      <el-image class="upimg_block upimg_btn" :class="status <= 1   ? '' : 'weImg'" :src="upImgUrl" abort="" fit="contain"></el-image>
      <img class="tg" v-if="status == 1" src="../assets/tg.png">
      <div class="we we1"  v-if="status == 2" >审核中</div>
      <div class="we we2"  v-if="status == 3" >已驳回</div>
    </div>
    <div class="upimg_block upimg_btn" v-else>
      <i class="el-icon-plus avatar-uploader-icon" style="font-size: 8.26rem;color: #999999;"></i>
      <div class="upimg_btn_text"></div>
    </div>
  </el-upload>
</template>

<script>
import {Toast} from "mint-ui";
import * as imageConversion from 'image-conversion'

export default {
  props: {
    status: {
      type: Number,
      default: 2
    },
    upImgUrl: {
      type: String,
      default: ""
    },
    uploadKey: {
      type: String,
      default: ""
    },
    token: {
      type: String,
      default: ""
    },
    onBeforeUpload: {
      type: Function,
      default: null
    },
    onSuccess: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      // upImgUrl: "",
      loading: false,
      disabled: false,
    }
  },
  methods: {
    beforeUpload(file) {
      let fileSize = file.size
      const isLt8M = fileSize / 1024 / 1024 < 10;
      if (!isLt8M) {
        Toast({
          message: '图片过大请重新选择',
          duration: 2000,
          iconClass: 'icon el-icon-error'
        })
        return false;
      }
      this.disabled = true
      this.loading = true

      this.onBeforeUpload(this.uploadKey)

      let maxSize = fileSize / 2
      return new Promise((resolve) => {
        // 压缩到100KB,这里的100就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, maxSize).then(res => {
          resolve(res);
        });
      })
    },

    uploadAttrFile(file) {
      let formData = new FormData();
      formData.append("file", file.file)
      formData.append("params", this.uploadKey);
      formData.append("token", this.token);
      //添加请求头 通过form添加的图片和文件的格式必须是multipart/form-data
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };
      let that = this
      that.$axios.post("https://api.songshuiqishi.com/h5/v1/image/apply/upload/three",formData,config).then(function(res){
          if (res.data.data) {
            that.onSuccess(res.data)
            // that.upImgUrl = res.data.data.path
          }
        }).catch(function (error) {
          console.log(error);
        }).finally(() => {
        that.loading = false
        that.disabled = false
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/upload.vue